module.exports = __webpack_public_path__ + "static/media/vote.08ba4e76.svg";